import React, { memo } from 'react'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import CommonText from 'common/components/entities/TextNew/ui/TextUi'
import { TextInterface } from 'common/types/entities/TextInterface'
import { usePopupOpenerRef } from 'publisher/hooks/use-popup-opener-ref'
import { useDelay } from 'publisher/hooks/useDelay'
import { useCalculateTypography } from 'src/publisher/shared/hooks/use-calculate-typography'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'

export interface TextProps {
  entity: TextInterface
}

const Text = ({ entity }: TextProps) => {
  const ref = usePopupOpenerRef()
  const isVisible = useDelay(entity.delay)
  const {
    calculatedFontSize,
    calculatedLineHeight,
    calculatedTextAlign,
    calculatedLetterSpacing,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateTypography({
    fontSize: entity.fontSize,
    mobileFontSize: entity.mobileFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    textAlign: entity.textAlign,
    mobileTextAlign: entity.mobileTextAlign,
    letterSpacing: entity.letterSpacing,
    mobileLetterSpacing: entity.mobileLetterSpacing,
    fontFamily: entity.fontFamily,
    mobileFontFamily: entity.mobileFontFamily,
    fontWeight: entity.fontWeight,
    mobileFontWeight: entity.mobileFontWeight,
    fontStyle: entity.fontStyle,
    mobileFontStyle: entity.mobileFontStyle,
  })
  const {
    text: { paragraphTextColor, paragraphBackgroundColor },
    links: { linkTextColor },
  } = useThemeColor()

  return isVisible ? (
    <StyleWrapper
      appearance={entity.appearance}
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
    >
      <CommonText
        id={entity.htmlAttrId}
        linkColor={linkTextColor}
        fontSize={calculatedFontSize.desktop}
        fontFamily={calculatedFontFamily.desktop}
        mobileFontFamily={entity.mobileFontFamily}
        mobileFontSize={calculatedFontSize.mobile}
        lineHeight={calculatedLineHeight.desktop}
        mobileLineHeight={calculatedLineHeight.mobile}
        color={paragraphTextColor}
        padding={entity.padding}
        fontStyle={calculatedFontStyle.desktop}
        mobileFontStyle={calculatedFontStyle.mobile}
        fontWeight={calculatedFontWeight.desktop}
        mobileFontWeight={calculatedFontWeight.mobile}
        mobilePadding={entity.mobilePadding}
        textAlign={calculatedTextAlign.desktop}
        mobileTextAlign={calculatedTextAlign.mobile}
        backgroundColor={entity.backgroundColor || paragraphBackgroundColor}
        mobileBackgroundColor={
          entity.mobileBackgroundColor || paragraphBackgroundColor
        }
        letterSpacing={calculatedLetterSpacing.desktop}
        mobileLetterSpacing={calculatedLetterSpacing.mobile}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: entity.content || entity.html || '',
          }}
          ref={ref}
        />
      </CommonText>
    </StyleWrapper>
  ) : (
    <div />
  )
}

export default memo(Text)
